<template>
    <inline-form class="form vue-ready__hide" :action="action" @success="onSuccess">
        <div slot-scope="props">
            <slot v-bind="props" :success="formSubmissionSuccess"/>
        </div>
    </inline-form>
</template>

<script>
    import InlineForm from 'framework/global-components/dyn/form/inline-form/inline-form';
    import { mapActions } from 'vuex';

    export default {
        components: { InlineForm },
        props: {
            action: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                formSubmissionSuccess: false,
            };
        },

        methods: {
            ...mapActions('cookie', ['setCookieAck']),

            onSuccess() {
                this.setCookieAck({ ack: true });
                this.formSubmissionSuccess = true;
            },
        },

        watch: {
            formSubmissionSuccess(value) {
                if (value === true) {
                    setTimeout(() => {
                        this.formSubmissionSuccess = false;
                    }, 2000);
                }
            },
        },
    };
</script>
